angular.module('app')
    .controller('assistenzaTecnicaCtrl', function (
        $scope,
        RichiestePostVendita,
        $transactionFactory,
        $configService,
        $location
    ) {
       
        if (!$transactionFactory.get()) {
            $scope.richiestePostVendita = RichiestePostVendita.build();
        } else {
            $scope.richiestePostVendita = $transactionFactory.get();
            $transactionFactory.clear();
        }


        $scope.indietro = function(){
            $location.path("/")
        }
    })